export default __webpack_public_path__ + "static/media/service-port.4d6f9bc7.svg";